module.exports = __webpack_public_path__ + "static/media/monitoring.63e7be1b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/equinixIcon/monitoring.svg
// module id = 1106
// module chunks = 49